var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// window.moment = moment;
// require('bootstrap-five');

// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
require('bootstrap-five/js/dist/collapse');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/accordion');
// require('bootstrap-five/js/dist/dropdown');
// require('bootstrap-five/js/dist/tab');
require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/tooltip');

// import Swiper from 'swiper';
// import { Navigation, Pagination, LazyLoading } from 'swiper/modules';

// require('masonry-layout/dist/masonry.pkgd');
require('isotope-layout/dist/isotope.pkgd');
require('imagesloaded');


const WOW = require('wow.js');

// import Swiper from 'swiper/bundle';
// window.Swiper = Swiper;
// import '/js/plugins/slider-menu.js';


// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');


require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    // alert('s')

    // $( window ).on( "load", function() {
        $('.grid').isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-sizer'
            }
        })

        $('.grid').each(function(){
        var $module = $(this);
        var update = function(){
            $module.isotope('layout'); // fix lazyload overlapping issues
        };
        // Note: Instead of waiting for all images until we initialize the widget
        // we use event capturing to update the widget's layout progressively.
        this.addEventListener('load', update, true);

        $module.isotope();
    });

    // });


    slideMenu();
    $( '.main-menu' ).sliderMenu();

    $('.pop-image').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },

    });

    new WOW().init({});


    /* $('#btn-menu').on('click', function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    }); */


    var video = document.getElementById("heroVideo");

    $('#btn-pause').on('click', function() {
        video.pause();
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-play").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-play').on('click', function() {
        video.play();
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-pause").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-mute').on('click', function() {
        $(video).prop('muted', false);
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-volume").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-volume').on('click', function() {
        $(video).prop('muted', true);
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-mute").addClass('d-flex').removeClass('d-none');
    });
/*
    $('#btn-menu').on('click', function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    }); */

    $(window).on('resize load scroll', function() {
    // var headerHeight = $('.navbar--main').outerHeight();
        var scroll = $(window).scrollTop();

        if (scroll >= 48 ) {  //scroll top menu out of view
            $('#header').addClass("down");
        } else {
            $('#header').removeClass("down");
        }
    });

    $('.hamburger').click(function(){
        $(this).toggleClass("is-active");
         $('.sidebar-offcanvas').toggleClass('active');
        //  $('.main-nav').toggleClass('down');

    });

});

function slideMenu(){
    $.fn.sliderMenu = function() {
    $( this ).each( function() {
      var $menu       = $( this ).clone(),
          $newMenu    = $( '<div>' ).addClass( 'slider-menu' ),
          $nav        = $( '<nav>' ).addClass( 'slider-menu__container' )
                                    .attr({
                                      'role':       'navigation',
                                      'aria-label': 'Menu'
                                    }),
          currentLeft = 0;

      // Build the new menu.
      $menu.attr( 'class', 'slider-menu__menu' );
      $( 'ul', $menu ).addClass( 'slider-menu__menu' )
                      .append( '<li><a href="#" class="slider-menu__back"><span class="slider-menu__text"><img class="back-icon" src="/img/site/icons/chevron-right.svg" width="40" height="40" loading="lazy" alt="next icon"> Back</span></a>' )
                      .parent().addClass( 'slider-menu--has-children' );
      $( 'li', $menu ).addClass( 'slider-menu__item' );
      $( 'a', $menu ).addClass( 'slider-menu__link' );
      $nav.html( $menu );
      $( '[data-vertical="true"]', $nav ).addClass( 'slider-menu__item--vertical' );
      $newMenu.html( $nav );

      // Interaction functionality.
      $( $newMenu ).on( 'click', '.slider-menu__link', function( e ) {
        var $clickedLink = $( this ),
            $container   = $clickedLink.closest( '.slider-menu' ),
            $parentItem  = $clickedLink.parent( '.slider-menu__item' ),
            $parentMenu  = $parentItem.parent( '.slider-menu__menu' ),
            $childMenu   = $( '> .slider-menu__menu', $parentItem );

        if ( $childMenu.length || $clickedLink.hasClass( 'slider-menu__back' ) ) {
          e.preventDefault();

          if ( $parentItem.data( 'vertical' ) ) {
            // Vertical menu.
            if ( $childMenu.is( ':visible' ) ) {
              // Hide
              $parentMenu.addClass( 'slider-menu--active' );
              $childMenu.hide();
              $container.css( 'height', $parentMenu.height() );
              /*$childMenu.slideUp( 200, function() {
                $container.css( 'height', $parentMenu.height() );
              });*/
              $clickedLink.removeClass( 'slider-menu__link--active-link' );
            } else {
              // Show
              $childMenu.show();
              $container.css( 'height', $parentMenu.height() );
              /*$childMenu.slideDown( 200, function() {
                $container.css( 'height', $parentMenu.height() );
              });*/
              $clickedLink.addClass( 'slider-menu__link--active-link' );
            }
          } else {
            $( '.slider-menu__item--vertical .slider-menu__menu', $container ).hide();
            $( '.slider-menu__item--vertical .slider-menu__link', $container ).removeClass( 'slider-menu__link--active-link' );

            // Horizontal menu.
            if ( $clickedLink.hasClass( 'slider-menu__back' ) ) {
              // Go back.
              var $activeMenu = $parentMenu.parent().parent();

              currentLeft -= 100;

              $nav.css( 'left', '-' + currentLeft + '%' );

              $parentMenu.removeClass( 'slider-menu--active' );
              $activeMenu.addClass( 'slider-menu--active' )
                         .parents( '.slider-menu__menu' ).addClass( 'slider-menu--active' );

              $container.css( 'height', $activeMenu.height() );
            } else {
              currentLeft += 100;

              $nav.css( 'left', '-' + currentLeft + '%' );

              $parentMenu.removeClass( 'slider-menu--active' );
              $childMenu.addClass( 'slider-menu--active' )
                        .parents( '.slider-menu__menu' ).addClass( 'slider-menu--active' );

              $container.css( 'height', $childMenu.height() );
            }
          }
        }
      });

      // Replace the current menu.
      $( this ).replaceWith(  $newMenu  );
    });
  };
};


window.recaptchaInit = function (parent) {
    let gClass = '.g-recaptcha';
    if (parent !== undefined) {
        gClass = parent + ' .g-recaptcha';
    }
    $(gClass).each(function() {
        var el = $(this);
        if (grecaptcha) {
            try {
                grecaptcha.render($(el).attr("id"), {});
            } catch(error){
                // duplicate errors
            }
        }
    });
    window.dispatchEvent(new CustomEvent('recaptcha-init'));
}
